import React from 'react';
import { MyTableContainer } from './style';

const MyTable = ({ children, ...otherProps }) => (
  <MyTableContainer className="table table-hover table-striped" {...otherProps}>
    {children}
  </MyTableContainer>
);

export default MyTable;